import SkillTags from "./SkillTags";

function ExperienceItem({ title, company, dates, bullets, skills }) {
  return (
    <div className="experience-container">
      <div className="experience-title">
        <h5>{title}</h5>
        <h5 className="subtle">{company}</h5>
        <p className="subtle">{dates}</p>
      </div>
      {bullets && (
        <div className="experience-description">
          {bullets.length > 0 && (
            <ul>
              {bullets.map((bullet, index) => (
                <li key={index} className="subtle">
                  {bullet}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
      {skills && skills.length > 0 && <SkillTags skills={skills} />}
    </div>
  );
}

export default ExperienceItem;
